import * as React from "react";
import { ZCatalogAction } from "src/business/catalog/ZCatalog";
import { ZId } from "src/types";

import { CreateActionRenderer } from "./actionRenderers/CreateActionRenderer";
import { WorkflowCreateActionRenderer } from "./actionRenderers/WorkflowCreateActionRenderer";

type PropsRecordsPageActions = {
  actions?: ZCatalogAction[] | null;
  catalogId: ZId;
};

const renderAction = (action: ZCatalogAction, catalogId: ZId) => {
  switch (action.type) {
    case "create":
      return <CreateActionRenderer {...action} catalogId={catalogId} />;
    case "workflowCreate":
      return <WorkflowCreateActionRenderer {...action} catalogId={catalogId} />;
    default:
      return null;
  }
};

const getActionKey = (action: ZCatalogAction, index: number) => {
  switch (action.type) {
    case "create":
      return `${action.type}:${index}`;
    case "workflowCreate":
      return `${action.type}:${action.workflowId}:${index}`;
    default:
      return index;
  }
};

export const RecordsPageActions: React.FC<PropsRecordsPageActions> = ({
  catalogId,
  actions,
}) =>
  actions?.map((action, index) => (
    <React.Fragment key={getActionKey(action, index)}>
      {renderAction(action, catalogId)}
    </React.Fragment>
  ));
